import { pathJoin } from '../../../../utils'
import { createDetailRoutesMap } from './detailed-view'

export const createContainerRoutesMap = (prefix: string) => ({
  '/:id': (id: string) =>
    pathJoin(prefix)(id).chainMapAuto(createDetailRoutesMap),
})
